import { useTranslation } from "react-i18next";
import { Clock, Plane, RotateCcw, Bell, CalendarClock, AlertTriangle, Stethoscope } from "lucide-react";
import { Field } from "../../../components/neu/Field";
import { Toggle } from "./Toggle";

const NUMBERS = [
  ["monthly_hours_target", "branches.monthlyHours", 0, "sky", Clock],
  ["annual_leave_days", "branches.annualLeaveDays", 30, "violet", Plane],
  ["carry_over_days", "branches.carryOverDays", 0, "emerald", RotateCcw],
  ["min_notice_days", "branches.minNoticeDays", 3, "amber", Bell],
  ["eligibility_after_months", "branches.eligibilityMonths", 6, "rose", CalendarClock],
  ["emergency_leave_days_year", "branches.emergencyDays", 5, "orange", AlertTriangle],
  ["sick_leave_days_year", "branches.sickDays", 15, "cyan", Stethoscope],
];

const FLAGS = [
  ["annual_leave_paid", "branches.annualPaid"],
  ["sick_leave_paid", "branches.sickPaid"],
  ["emergency_leave_paid", "branches.emergencyPaid"],
  ["sick_requires_certificate", "branches.sickCertificate"],
  ["allow_unpaid_leave", "branches.allowUnpaidLeave"],
];

// موافقة المدير على إلغاء/استئناف الإجازة — مستقلة لكل نوع.
const RESUME_FLAGS = [
  ["resume_needs_approval_annual", "branches.resumeApproval.annual"],
  ["resume_needs_approval_sick", "branches.resumeApproval.sick"],
  ["resume_needs_approval_emergency", "branches.resumeApproval.emergency"],
  ["resume_needs_approval_unpaid", "branches.resumeApproval.unpaid"],
];

// Shared leave-policy editor used for the company policy and for each branch override.
export const LeavePolicyFields = ({ value = {}, onChange, defaults }) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-5 sm:grid-cols-2">
      {NUMBERS.map(([key, label, fallback, accent, icon]) => (
        <div key={key}>
          <Field
            label={t(label)} testId={`branch-${key}`} type="number"
            value={value[key] ?? defaults?.[key] ?? fallback}
            onChange={(v) => onChange(key, Number(v))}
            accent={accent} icon={icon}
          />
          {key === "eligibility_after_months" ? (
            <p className="mt-1 text-xs text-muted-foreground">{t("branches.eligibilityHint")}</p>
          ) : null}
          {defaults && defaults[key] !== undefined ? (
            <p className="mt-1 text-[11px] font-semibold text-muted-foreground" data-testid={`inherited-${key}`}>
              {t("branches.companyDefault", { value: defaults[key] })}
            </p>
          ) : null}
        </div>
      ))}

      {FLAGS.map(([key, label]) => (
        <Toggle
          key={key} label={t(label)} testId={`branch-${key}`}
          value={value[key] ?? defaults?.[key] ?? true}
          onChange={(v) => onChange(key, v)}
        />
      ))}

      <div className="sm:col-span-2">
        <p className="label-xs mb-3 text-sm">{t("branches.resumeApprovalTitle")}</p>
        <div className="grid gap-5 sm:grid-cols-2">
          {RESUME_FLAGS.map(([key, label]) => (
            <Toggle
              key={key} label={t(label)} testId={`branch-${key}`}
              value={value[key] ?? defaults?.[key] ?? false}
              onChange={(v) => onChange(key, v)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
